import Vue from "vue";

const AppDrawer = () => import(/* webpackPrefetch: true */ "./Drawer.vue");
Vue.component("AppDrawer", AppDrawer);
